module.exports = __webpack_public_path__ + "img/home-contact.99bd1a15.jpg";